// dependencies
import moment from "moment";
import { Map, List } from "immutable";
import { createSelector } from "reselect";
import { getMatchedRouteKeyValue } from "yarrr";

// selectors
import { getUI } from "Selectors/ui";
import { getCompanyUsersObject } from "Selectors/company";

export const getData = (state) => getUI(state).get("data", List());
export const getDataCount = (state) => getData(state).size;

export const getPageLimit = (state) => getUI(state).get("limit", 0);
export const getPageSize = (state) => getUI(state).get("pageSize", 1);
export const getCurrentPage = (state) => getUI(state).get("currentPage", 1);
export const getInitalized = (state) => getUI(state).get("initalized", false);
export const getCompany = (state) => getUI(state).get("company", Map());
export const getCompanyID = (state) => getMatchedRouteKeyValue(state, "companyID", null);

export const getCurrentQuery = (state) => getUI(state).getIn(["currentQuery"], "");

// company functions
export const getIntegrationValue = (state) => getUI(state).getIn(["company", "functions", "hr-integration"], "none");

export const getOriginalIntegrationValue = (state) =>
	getUI(state).getIn(["originalCompany", "functions", "hr-integration"], "none");

export const getLastSyncDate = (state) => {
	const lastSync = getUI(state).getIn(["company", "lastSync"]);
	if (lastSync === undefined) {
		return null;
	}

	const lastSyncMoment = moment(lastSync).format("YYYY-MM-DD hh:mm a");
	return lastSyncMoment;
};

/** Get company users */
export const getCompanyUsers = createSelector(
	[getCompanyID, getCompanyUsersObject, getCurrentQuery],
	(companyID, companyUsersObject, currentQuery) =>
		companyUsersObject.getIn([companyID, currentQuery, "users", "list"], List())
);

/**
 * Gets the skip count based on the current page and limit
 */
export const getSkipCount = (state) => {
	const limit = getPageLimit(state);
	const currentPage = getCurrentPage(state);

	return (currentPage - 1) * limit;
};

/**
 * Calculate the page count
 */
export const getPageCount = (state) => {
	const usersCount = getDataCount(state);
	const limitCount = getPageLimit(state);

	return Math.ceil(usersCount / limitCount);
};

/**
 * Get the selected view
 */
export const selectView = (state) => {
	const view = getMatchedRouteKeyValue(state, "view");
	const viewID = getMatchedRouteKeyValue(state, "viewID");

	return {
		view: view || "snapshot",
		viewId: viewID || null,
	};
};
